import { useSearchParams } from "react-router-dom";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../components/ui/tabs";
import Workspaces from "./Workspaces";
import ClientRules from "./ClientRules";
import UserAccess from "./UserAccess";
import Settings from "./Settings";
import { ShieldCheck } from "@phosphor-icons/react";

const TABS = [
  { key: "workspaces", label: "Workspaces" },
  { key: "client-rules", label: "Client Rules" },
  { key: "user-access", label: "User Access" },
  { key: "settings", label: "Settings" },
];

export default function Admin() {
  const [params, setParams] = useSearchParams();
  const tab = params.get("tab") || "workspaces";

  return (
    <Tabs value={tab} onValueChange={(v) => setParams({ tab: v })} className="flex flex-col h-full" data-testid="admin-page">
      <div className="px-6 pt-5 border-b border-[var(--c-border)] bg-[var(--c-bg)] shrink-0">
        <div className="flex items-center gap-2.5">
          <ShieldCheck size={18} weight="duotone" className="text-[var(--c-accent)]" />
          <h1 className="text-2xl tracking-tight font-medium text-[var(--c-text)]" data-testid="admin-title">Admin</h1>
        </div>
        <TabsList className="bg-transparent p-0 gap-5 h-10 mt-2">
          {TABS.map((t) => (
            <TabsTrigger key={t.key} value={t.key} data-testid={`admin-tab-${t.key}`}
              className="rounded-none border-b-2 border-transparent data-[state=active]:border-[var(--c-accent)] data-[state=active]:bg-transparent data-[state=active]:shadow-none px-1 pb-2.5 text-xs text-[var(--c-muted)] data-[state=active]:text-[var(--c-text)] transition-colors duration-150">
              {t.label}
            </TabsTrigger>
          ))}
        </TabsList>
      </div>
      <TabsContent value="workspaces" className="m-0 flex-1 overflow-y-auto p-6"><Workspaces /></TabsContent>
      <TabsContent value="client-rules" className="m-0 flex-1 overflow-y-auto"><ClientRules /></TabsContent>
      <TabsContent value="user-access" className="m-0 flex-1 overflow-y-auto p-6"><UserAccess /></TabsContent>
      <TabsContent value="settings" className="m-0 flex-1 overflow-y-auto"><Settings /></TabsContent>
    </Tabs>
  );
}
